export const SEPARATOR = ',';
export const PAGE_SIZE = 20;
export const DEFAULT_TIME_FORMAT = '00:00:00';

export const PAYMENT_STATUS = {
  StatusUknown: 'STATUS_UKNOWN',
  Created: 'CREATED',
  Authorized: 'AUTHORIZED',
  Captured: 'CAPTURED',
  Refunded: 'REFUNDED',
  Canceled: 'CANCELED',
  Failed: 'FAILED',
  InternalError: 'INTERNAL_ERROR'
};
export const ACTIVE_TAB = 'type';

export const PAYMENT_FILTERS_TYPE = {
  List: 'LIST',
  Search: 'SEARCH'
};
